import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { ORM } from 'utility-ts-orm';
import { IStudygroupsPriorityFeedDatasource } from '../datasources/study_groups_priority_feed_datasource';
import { IStudyGroupSection } from '../study_group_interfaces';

export class StudyGroupsPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _count: number;
  private sections: IStudyGroupSection[];
  private isNewStudent: boolean;

  constructor(private ngStudygroupsPriorityFeedDatasource: IStudygroupsPriorityFeedDatasource) {
    this.isNewStudent = false;
    ORM.registerQuery(this, ngStudygroupsPriorityFeedDatasource);
  }

  run() {
    const feedCard = _4.first(this.ngStudygroupsPriorityFeedDatasource.values());
    // { "content_type": "study.buddy", "title": "You have 1 classmate looking for Study Buddies in the last 1 hour", "description": "Check out Study Buddies groups today", "new_study_buddy_count": 1 }
    this._result = {
      icon: { type: 'users', theme: 'teal' },
      isOverdue: false,
      isActive: !!feedCard,
      text: {
        title: feedCard ? feedCard.title : '',
        subTitle: feedCard ? feedCard.description : ''
      },
      action: {
        state: 'my.studyGroups'
      }
    };
    this._count = _4.get(feedCard, 'new_study_buddy_count', 0);
    return this;
  }

  get hasFeedNotification() {
    return this.result.isActive || false;
  }

  get result() {
    return this._result;
  }

  get count() {
    return this._count;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/queries/study_groups_priority_feed_query.ts